import { Link } from 'react-router-dom';
import { ctaData } from '@/mocks/home';

export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row">
      <div className="lg:w-1/2 relative min-h-[400px] md:min-h-[500px] bg-background-100 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20woman%20reading%20a%20book%20in%20a%20cozy%20cafe%2C%20warm%20sunlight%20streaming%20through%20large%20window%2C%20soft%20cream%20and%20peach%20tones%2C%20peaceful%20and%20immersive%20atmosphere%2C%20delicate%20details%2C%20digital%20art%20style%2C%20vertical%20composition%2C%20clean%20and%20elegant%20aesthetic%2C%20reading%20and%20relaxation%20theme&width=960&height=1200&seq=cta-comic-art&orientation=portrait"
          alt="沉浸式韩漫阅读"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-100/60 via-transparent to-transparent"></div>
        <div className="absolute top-8 left-8 md:top-10 md:left-10">
          <span className="text-xs font-medium text-foreground-600 bg-background-50/80 backdrop-blur-sm px-3 py-1.5 rounded-full">
            {ctaData.tag}
          </span>
        </div>
        <div className="absolute bottom-8 left-8 md:bottom-10 md:left-10">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-black text-foreground-900 leading-tight">
            {ctaData.titleLine1}
            <br />
            {ctaData.titleLine2}
            <br />
            {ctaData.titleLine3}
          </h2>
        </div>
      </div>

      <div className="lg:w-1/2 flex items-center justify-center py-16 md:py-20 px-6 md:px-16 bg-background-50">
        <div className="max-w-md text-center">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-black text-foreground-900 leading-tight">
            {ctaData.rightTitleLine1}
            <br />
            {ctaData.rightTitleLine2}
          </h2>
          <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed">
            {ctaData.description}
          </p>
          <Link
            to={ctaData.ctaLink}
            className="mt-8 inline-flex items-center gap-2 bg-foreground-900 text-background-50 px-8 py-3.5 rounded-full text-sm md:text-base font-semibold hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            {ctaData.ctaText}
            <i className="ri-arrow-right-line text-lg"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}